<script>
import Input from 'dashboard/components-next/input/Input.vue';
import ComboBox from 'dashboard/components-next/combobox/ComboBox.vue';

export default {
  components: {
    Input,
    ComboBox,
  },
  props: {
    modelValue: { type: Object, required: true },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      httpMethods: ['GET', 'POST', 'PATCH', 'PUT', 'DELETE'].map(item => ({
        label: item,
        value: item.toLowerCase(),
      })),
      state: {
        url: '',
        http_method: 'post',
        header: '',
        body: '',
      },
    };
  },
  mounted() {
    let { url, http_method, header, body } = this.modelValue?.[0] || {};
    this.state = { url, http_method, header, body };
  },
  methods: {
    updateValue() {
      this.$emit('update:modelValue', { ...this.state });
    },
  },
};
</script>

<template>
  <div>
    <Input
      v-model="state.url"
      :placeholder="$t('AUTOMATION.ACTION.URL_INPUT_PLACEHOLDER')"
      class="mt-2"
      label="API Url"
      type="url"
      @update:model-value="updateValue"
    />
    <div class="flex flex-col gap-1 mt-2">
      <label
        class="mb-0.5 text-sm font-medium text-n-slate-12"
        for="http_method"
      >
        {{ 'API Method' }}
      </label>
      <ComboBox
        id="http_method"
        v-model="state.http_method"
        :options="httpMethods"
        class="[&>div>button]:bg-n-alpha-black2 [&>div>button:not(.focused)]:dark:outline-n-weak [&>div>button:not(.focused)]:hover:!outline-n-slate-6"
        placeholder="Select"
        @update:model-value="updateValue"
      />
    </div>
    <Input
      v-model="state.header"
      class="mt-2"
      label="API Header"
      placeholder='{"token": "ERP Token"}'
      type="text"
      @update:model-value="updateValue"
    />
    <label class="mt-2">
      {{ 'API Body' }}
      <textarea
        v-model="state.body"
        class="bg-n-alpha-black2"
        placeholder='{"phone_number": "CUSTOMER Phone"}'
        rows="4"
        @update:model-value="updateValue"
      />
    </label>
  </div>
</template>

<style scoped>
textarea {
  margin-bottom: var(--space-zero);
}
</style>
